import type { AllRouteEndpoints } from "../routeTypes";

// If applicable consider also updating engagementLandingPagesAppGroupIdLandingPageIdCacheKeys
export const engagementLandingPagesAppGroupIdUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id",
  "/engagement/landing_page_data",
  "/engagement/landing_pages_data",
  "/engagement/landing_pages/:app_group_id/:landing_page_bson_id/preview",
  "/engagement/landing_pages/:app_group_id/limits",
];
